//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconCommentAdd(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13 14V11H16V9H13V6H11V9H8V11H11V14H13Z" fill="currentColor" /><path d="M2 2V18H10V16H4V4H20V16H14.53L9.5 22H12.11L15.47 18H22V2H2Z" fill="currentColor" /></svg>;
}
export default IconCommentAdd;